/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useState } from 'react'
import { Content, CriteriaRow, Title } from '../../core/screen-util'
import { ErrorContext, SpinContext } from 'context'
import { Button, message, Upload } from 'antd'
import { getApiTargetInfo, getUserName } from 'core'

import {
  isErrorContains,
  JcTmpErrorTable,
} from '../../core/component/JcTmpErrorDialog'
import { connect } from 'react-redux'
import { getAuthorization, getCredentials } from 'api/pgads'

const NetCapVerificationImport = ({ targetInfo }) => {
  const [errorData, setErrorData] = useState([])
  const { setError } = useContext(ErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const fileProps = {
    name: 'file',
    action: `${targetInfo.baseUrl}/pjm/net-cap-verification-import`,
    method: 'POST',
    data: {},
    headers: getAuthorization(targetInfo),
    ...getCredentials(targetInfo),
  }

  return (
    <div style={{ marginTop: '10px' }}>
      <CriteriaRow>
        <Title css={{ marginRight: '50px' }}>
          Net Capacity Verification Import
        </Title>
        <Upload
          {...fileProps}
          beforeUpload={_ => {
            setSpinning(true)
            setErrorData([])
          }}
          onChange={data => {
            if (data.file.status === 'error') {
              setSpinning(false)
              setError(data.file.response)
              message.error(`${data.file.name} file upload failed.`)
            } else if (data.file.status === 'done') {
              // setImportResponse(data.file.response)
              setSpinning(false)
              const errors = data.file.response
              if (errors.length > 0) setErrorData(errors)
              if (!isErrorContains(errors))
                message.success('File imported successfully')
            }
          }}
          multiple={false}
          showUploadList={false}
        >
          <Button icon="upload" loading={spinning}>
            Import
          </Button>
        </Upload>
      </CriteriaRow>
      <Content>
        <JcTmpErrorTable errors={errorData} scroll={{ y: 600 }} />
      </Content>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  userName: getUserName(state),
})

export default connect(mapStateToProps)(NetCapVerificationImport)
